// extracted by mini-css-extract-plugin
export default {"links":"ProjectLinks_links__5S32T","primary":"ProjectLinks_primary__17uUt","secondary":"ProjectLinks_secondary__ur9b5","light":"ProjectLinks_light__e7c5C"};